module.exports = __webpack_public_path__ + "static/media/KMH_5357.74135163.jpg";